import simpleRestProvider from "ra-data-simple-rest";
import { fetchUtils } from "react-admin";
import {
  clearStoredAuthState,
  ensureFreshToken,
  getSecondsUntilTokenExpiry,
  handleExpiredSession,
  refreshToken,
} from "../authProvider";

type SendRequestOptions = {
  rawResponse?: boolean;
  absoluteUrl?: boolean;
  init?: RequestInit;
};

const buildHeaders = (extraHeaders?: HeadersInit) => {
  const headers = new Headers({ Accept: "application/json" });

  headers.set("reqDivision", localStorage.getItem("division") ?? "");
  headers.set("reqBank", localStorage.getItem("bank") ?? "");
  headers.set("reqAdmin", localStorage.getItem("permissions") ?? "");
  headers.set(
    "Authorization",
    `Bearer ${localStorage.getItem("access_token") ?? ""}`
  );
  headers.set("X-CSRF-TOKEN", "");
  headers.set("X-XSRF-TOKEN", "");
  headers.set("reqType", "");

  if (extraHeaders) {
    new Headers(extraHeaders).forEach((value, key) => {
      headers.set(key, value);
    });
  }

  return headers;
};

const buildRequestUrl = (
  apiBaseUrl: string,
  url: string,
  absoluteUrl = false
) => {
  if (absoluteUrl || /^https?:\/\//i.test(url)) {
    return url;
  }

  return `${apiBaseUrl}/${url.replace(/^\//, "")}`;
};

const sendRequest = async (
  url: string,
  data: any,
  method = "update",
  options: SendRequestOptions = {}
) => {
  await ensureFreshToken();

  const fetchJson = async (requestUrl: string, requestOptions: any = {}) => {
    requestOptions.user = {
      authenticated: true,
      token: localStorage.getItem("token"),
    };
    requestOptions.headers = buildHeaders(requestOptions.headers);

    try {
      return await fetchUtils.fetchJson(requestUrl, requestOptions);
    } catch (error) {
      const requestError = error as { status?: number };

      if (requestError.status === 401 && getSecondsUntilTokenExpiry() <= 0) {
        await refreshToken();
        requestOptions.headers = buildHeaders(requestOptions.headers);
        return await fetchUtils.fetchJson(requestUrl, requestOptions);
      }

      throw error;
    }
  };

  const apibaseurl = import.meta.env.VITE_API_URL;
  const dataProvider = simpleRestProvider(apibaseurl, fetchJson);

  try {
    if (options.rawResponse) {
      const requestUrl = buildRequestUrl(apibaseurl, url, options.absoluteUrl);

      const executeRawFetch = async () => {
        return await fetch(requestUrl, {
          method: method === "get" ? "GET" : "POST",
          ...options.init,
          headers: buildHeaders(options.init?.headers),
        });
      };

      let rawResponse = await executeRawFetch();
      if (rawResponse.status === 401 && getSecondsUntilTokenExpiry() <= 0) {
        await refreshToken();
        rawResponse = await executeRawFetch();
      }

      if (rawResponse.status === 401) {
        handleExpiredSession();
      }

      return rawResponse;
    }

    let response = null;

    if (method == "get") {
      if (data?.id !== undefined && data?.id !== null) {
        response = await dataProvider.getOne(url, data);
      } else {
        const requestUrl = buildRequestUrl(
          apibaseurl,
          url,
          options.absoluteUrl
        );
        const rawResponse = await fetchJson(requestUrl);

        return rawResponse.json ?? rawResponse.body;
      }
    } else if (method == "create") {
      response = await dataProvider.create(url, data);
    } else if (method == "delete") {
      response = await dataProvider.delete(url, data);
    } else {
      response = await dataProvider.update(url, data);
    }

    return response.data;
  } catch (error) {
    const requestError = error as {
      error?: string;
      message?: string;
      status?: number;
    };

    console.log("sendRequest message aaa===>", requestError.message);
    if (
      requestError.error == "Unauthenticated" ||
      requestError.status === 401 ||
      requestError.message == "Unauthenticated." ||
      requestError.message == "You must be logged in to access this resource."
    ) {
      handleExpiredSession();
      return Promise.reject(error);
    }
    console.log("sendRequest error===>", error);
  }
};

export default sendRequest;
